module.exports = __webpack_public_path__ + "static/media/maimonides.25bf1e6d.png";